import Vue from 'vue'
import Login from './Login.vue'

import '../../styles/index.less'
import '../quasar.js'

Vue.config.productionTip = false

/**
 * Значения генерируются автоматически при сборке.
 * См. в build.gradle task createBuildFile.
 */
var deltaVersion = '2.0'
var apiBuildDate = null
var apiBuildTime = null
var apiBuildNumber = null
var uiBuildDate = null
var uiBuildTime = null
var uiBuildNumber = null

var titleAdditional = ''
if (uiBuildDate) {
  titleAdditional = ' UI:' + uiBuildDate
  if (typeof uiBuildNumber == 'number' && uiBuildNumber > 1) {
    titleAdditional += '/' + uiBuildNumber
  }
}

var deltaSystemName = 'АС Дельта ' + deltaVersion
var deltaSystemTitle = deltaSystemName + titleAdditional
document.title = deltaSystemTitle

new Vue({ render: h => h(Login) }).$mount('#app')
